import { jsx as o } from "react/jsx-runtime";
import { Icon as r } from "./Icon.js";
const e = (C) => /* @__PURE__ */ o(r, { ...C, children: /* @__PURE__ */ o(
  "path",
  {
    d: "M12.1667 7.33333V5.66667C12.1667 3.36548 10.3012 1.5 8 1.5C5.69881 1.5 3.83333 3.36548 3.83333 5.66667V7.33333M8 11.0833V12.75M5.33333 16.5H10.6667C12.0668 16.5 12.7669 16.5 13.3016 16.2275C13.772 15.9878 14.1545 15.6054 14.3942 15.135C14.6667 14.6002 14.6667 13.9001 14.6667 12.5V11.3333C14.6667 9.9332 14.6667 9.23314 14.3942 8.69836C14.1545 8.22795 13.772 7.8455 13.3016 7.60582C12.7669 7.33333 12.0668 7.33333 10.6667 7.33333H5.33333C3.9332 7.33333 3.23314 7.33333 2.69836 7.60582C2.22795 7.8455 1.8455 8.22795 1.60582 8.69836C1.33333 9.23314 1.33333 9.9332 1.33333 11.3333V12.5C1.33333 13.9001 1.33333 14.6002 1.60582 15.135C1.8455 15.6054 2.22795 15.9878 2.69836 16.2275C3.23314 16.5 3.9332 16.5 5.33333 16.5Z",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  e as Lock
};
